import { render, staticRenderFns } from "./RemovedTask.vue?vue&type=template&id=702736be&"
import script from "./RemovedTask.vue?vue&type=script&lang=ts&"
export * from "./RemovedTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports